module.exports = __webpack_public_path__ + "img/canada.e6ae0a3f.svg";